import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'app-summary-card-header',
})
export class SummaryCardHeaderDirective {
  @HostBinding('class') elClass = 'summary-card-header';
}
